import { ModalType, selectModalProps } from '../slices/modal.slice';
import { Navigate, Outlet } from 'react-router-dom';
import { Suspense, useEffect, useState } from 'react';
import { selectIsCompact } from '../slices/compact.slice';
import CustomModal from '../components/Modal/Modal';
import LoadingOverlay from '../components/LoadingOverlay';
import React from 'react';
import Sidebar from '../layouts/Sidebar';
import { get } from 'lodash';
import { getStorageValue } from '../utils/cookies';
import isEmpty from 'lodash/isEmpty';
import modals from '../screens/Modals';
import { selectIsLoading } from '../slices/loading.slice';
import styles from '../layouts/Layouts.module.scss';
import { useAppSelector } from '../store/hooks';
import Header from '../layouts/Header';
import { useSelector } from 'react-redux';

const PrivateRoute = () => {
  const accessToken = getStorageValue('access_token') || '';
  const { modalName, modalOpen = false, styles: ModalStyles }: ModalType = useAppSelector(selectModalProps);
  const isLoading = useAppSelector(selectIsLoading) || false;
  const [ModalComponent, setModalComponent] = useState<React.ReactNode>(null);
  const isCompact = useSelector(selectIsCompact);
  useEffect(() => {
    const fetchModalComponent = async () => {
      const Component = await get(modals, modalName, React.Fragment);
      setModalComponent(<Component />);
    };
    fetchModalComponent();
  }, [modalName]);
  if (isEmpty(accessToken)) return <Navigate to='/login' />;
  return (
    <>
      <Header />
      <Sidebar />
      <div
        className={styles.layoutContainer}
        style={
          isCompact
            ? { marginLeft: "60px", transition: "0.5s ease" }
            : window.innerWidth <= 700
              ? { marginLeft: "60px", transition: "0.5s ease", position: "relative", zIndex: -1 }
              : { marginLeft: "220px", transition: "0.5s" }
        }
      >
        <Outlet />
      </div>

      <Suspense fallback={<LoadingOverlay isLoading={true} />}>
        <CustomModal open={modalOpen} styles={ModalStyles}>
          {ModalComponent}
        </CustomModal>
      </Suspense>
      <LoadingOverlay isLoading={isLoading} />
    </>
  );
};

export default PrivateRoute;
